import { isEmpty } from 'lodash';

export default function validatorPattern(pattern: RegExp, value: string) {
  if (isEmpty(value)) {
    return true;
  }

  const regex = new RegExp(pattern);
  return regex.test(value);
}
